import { create } from 'zustand'

// Plans checked in the Assortment Plans list (for SKU export). UI only;
// the page clears it whenever its filters change or it unmounts.
export const useAssortmentPlanSelectionStore = create<{
  selectedPlanIds: string[]
  selectPlans: (ids: string[], checked: boolean) => void
  clearSelection: () => void
}>((set, get) => ({
  selectedPlanIds: [],
  selectPlans: (ids, checked) => {
    const selected = new Set(get().selectedPlanIds)
    ids.forEach(id => (checked ? selected.add(id) : selected.delete(id)))
    set({ selectedPlanIds: [...selected] })
  },
  clearSelection: () => set({ selectedPlanIds: [] }),
}))
